var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNav5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "#222222",
    stroke: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.53 9.008C11.9754 8.2321 12.6681 7.62793 13.4973 7.29207C14.3266 6.9562 15.2445 6.90804 16.1043 7.15527C16.9641 7.40251 17.7163 7.93086 18.2405 8.65588C18.7646 9.38091 19.0306 10.2607 18.9959 11.1547C18.9612 12.0487 18.6278 12.9053 18.0489 13.5875C17.4701 14.2697 16.6793 14.7381 15.8028 14.9179C14.9264 15.0977 14.015 14.9785 13.2143 14.5793C12.4136 14.1802 11.7699 13.5241 11.386 12.716C11.1295 12.9036 10.8198 13.0045 10.502 13.004H10.002V13.259C10.002 13.449 10.074 13.622 10.192 13.753C10.2928 13.639 10.426 13.5584 10.5737 13.522C10.7215 13.4856 10.8768 13.4951 11.0191 13.5491C11.1614 13.6032 11.2838 13.6994 11.37 13.8247C11.4563 13.9501 11.5023 14.0988 11.502 14.251C11.5019 14.3555 11.48 14.4589 11.4376 14.5544C11.3952 14.65 11.3334 14.7356 11.256 14.8058C11.1786 14.8761 11.0874 14.9294 10.9882 14.9623C10.889 14.9952 10.784 15.007 10.68 14.997C10.2296 14.9812 9.80291 14.7912 9.48989 14.4669C9.17687 14.1427 9.00193 13.7097 9.00195 13.259V9.507C9.00195 9.37439 9.05463 9.24721 9.1484 9.15345C9.24217 9.05968 9.36934 9.007 9.50195 9.007H11.502L11.53 9.008ZM10.002 12.004H10.502C10.6346 12.004 10.7617 11.9513 10.8555 11.8576C10.9493 11.7638 11.002 11.6366 11.002 11.504V11.134C10.999 11.0447 10.999 10.9553 11.002 10.866V10.007H10.002V12.004Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18C8 16.887 8.903 16 10.009 16H20C20.5304 16 21.0391 16.2107 21.4142 16.5858C21.7893 16.9609 22 17.4696 22 18C22 19.691 21.167 20.966 19.865 21.797C18.583 22.614 16.855 23 15 23C13.145 23 11.417 22.614 10.135 21.797C8.833 20.967 8 19.69 8 18Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav5);
export default __webpack_public_path__ + "static/media/nav5.33eb3340bdf3bd3d6f12accc63b39dcd.svg";
export { ForwardRef as ReactComponent };